import React, { useEffect, useState } from "react";
import BgBox from "../../../common/BgBox";
import HeaderText from "../../../common/HeaderText";
import CardUI from "../../../common/Card";
import {
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MccLogo from "../../../components/MccLogo";
import { validateEmail } from "../../../utils/helpers";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import {
  createWorkspaceFunc,
  getAgentProfile,
  inviteAgentFunc,
  resetAgentInvite,
  resetCreateWorkSpace,
} from "../../../actions/Agency";
import AlertMessage from "../../../common/AlertMessage";
import { LoadingButton } from "@mui/lab";
import ExistingPractices from "../../../components/ExistingPracticesUI";
import AddPractiseContent from "../../../components/AddPractiseContent";
import { AddPractiseIcon } from "../../../assets/constants";
import axios from "axios";
import { BASE_URL } from "../../../actions";

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*.?])[A-Za-z\d!@#$%^&*.?]{8,}$/;

const JoinWorkspace = () => {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();

  const organizationId = Cookies.get("org_id_vita");

  const [showPractiseBox, setShowPractiseBox] = useState(true);
  const [addingMorePractice, setAddingMorePractice] = useState(false);
  const [practiceName, setPracticeName] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [specialtyId, setSpecialtyId] = useState("");
  const [specialtyError, setSpecialtyError] = useState(false);
  const [agencies, setAgencies] = useState([]);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [open, setOpen] = useState(false);
  const [openSuccessMessage, setOpenSuccessMessage] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setOpenSuccessMessage(false);
  };

  const { state } = useLocation();

  const agentData = state && state?.agent_data;
  const existingAgencies = state && state?.existing_agencies;

  const createWorkspace = useSelector((state) => state.createWorkspace);
  const {
    loading: loadingAgency,
    error: errorAgency,
    workspace,
  } = createWorkspace;

  const agentProfile = useSelector((state) => state.agentProfile);
  const {
    loading: loadingAgentProfile,
    error: errorAgentProfile,
    agentUser,
  } = agentProfile;

  const inviteAgent = useSelector((state) => state.inviteAgent);
  const {
    loading: loadingAgent,
    error: errorAgent,
    invitedAgent,
  } = inviteAgent;

  const emailChangeHandler = (e) => {
    const emailInputValue = e.target.value;
    setEmail(emailInputValue);

    const emailIsValid = validateEmail(emailInputValue);
    if (emailInputValue && !emailIsValid) {
      setEmailError(true);
      return;
    }
    setEmailError(false);
  };

  useEffect(() => {
    if (state === null) {
      navigate(-1);
      return;
    }
    Cookies.set("route", "/join-workspace");
  }, []);

  useEffect(() => {
    dispatch(getAgentProfile());
  }, []);

  useEffect(() => {
    if (existingAgencies && existingAgencies?.length) {
      setAgencies(existingAgencies);
    }
  }, [state]);
  const REACT_APP_SKIP_BILLING = false;
  const joinWorkspaceHandler = async () => {
      dispatch(resetAgentInvite());
  
      // if (process.env.REACT_APP_SKIP_BILLING === "true") {
      //   navigate("/password-created?billingCompleted=true");
      //   return;
      // }
  
        
      if (REACT_APP_SKIP_BILLING) {
        navigate("/password-created?billingCompleted=true");
        return;
      }
      const data = await secretKeyCallFunction();
  
      if (data?.ok) {
        navigate("/billing-details", {
          state: { createAgentName: true, client_secret: data?.client_secret },
        });
      }
  
      // navigate("/password-created", { state: { createAgentName: true, secret_key: } });
    };

  const secretKeyCallFunction = async () => {
    try {
      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const agent = agentUser?.agent;
        const fullName =
          agent?.name ||
          `${agent?.first_name || ""} ${agent?.last_name || ""}`.trim();

        const customerObj = {
          organization_id: Cookies.get("org_id_vita") || organizationId,
          email: agent?.email,
          name: fullName,
        };

        const response = await axios.post(
          `${BASE_URL}/subscription/create-customer`,
          customerObj,
          config
        );
        if (!response?.data?.ok) {
          throw new Error(response?.data?.msg || response?.data?.message);
        }

        return response?.data;
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const showMorePractiseHandler = () => {
    setShowPractiseBox(true);
    setAddingMorePractice(true);
  };

  const resetAddPracticeForm = () => {
    setEmail("");
    setPracticeName("");
    setOwnerName("");
    setSpecialtyId("");
    setSpecialtyError(false);
    setEmailError(false);
  };

  const closePractiseBoxHandler = () => {
    setShowPractiseBox(false);
    setAddingMorePractice(false);
    resetAddPracticeForm();
  };

  const addPracticeHandler = () => {
    if (!specialtyId) {
      setSpecialtyError(true);
      return;
    }

    const agencyObj = {
      agency: {
        name: practiceName,
        primary_email: email,
      },
      organization_id: organizationId,
      specialty_id: Number(specialtyId),
    };

    dispatch(createWorkspaceFunc(agencyObj));
    setEmailErrorMsg("");
  };

  useEffect(() => {
    if (!loadingAgency && !workspace?.ok) {
      setEmailErrorMsg(workspace?.message);
      setOpen(true);
    }
  }, [workspace]);

  useEffect(() => {
    if (!loadingAgent && !invitedAgent?.ok) {
      setEmailErrorMsg(invitedAgent?.message);
      setOpen(true);
      // setShowPractiseBox(false);
      resetAddPracticeForm();
    }
  }, [invitedAgent]);

  useEffect(() => {
    if (workspace?.data?.ok) {
      setAgencies((prevState) => [...prevState, workspace?.data?.agency]);
      const agentObj = {
        agency_id: workspace?.data?.agency?.id,
        send_credentials: true,
        agent_obj: {
          first_name: ownerName,
          email: email,
          roles: ["Owner", "Provider"],
          role: "Owner",
          permissions: {
            access_patient_details: {
              create: true,
              read: true,
              edit: true,
              delete: true,
            },
            // can_chat_client: true,
            can_access_billing: false,
          },
        },
      };
      dispatch(inviteAgentFunc(agentObj));
      dispatch(resetCreateWorkSpace());
    }
  }, [workspace]);

  useEffect(() => {
    if (invitedAgent?.ok) {
      setOpenSuccessMessage(true);
      setSuccessMessage(invitedAgent?.message);
      setEmailErrorMsg("");
      setShowPractiseBox(false);
      resetAddPracticeForm();
    }
  }, [invitedAgent]);

  if (state === null) {
    return;
  }

  return (
    <>
      {!loadingAgency && emailErrorMsg && (
        <AlertMessage
          message={emailErrorMsg}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      {openSuccessMessage && (
        <AlertMessage
          message={successMessage}
          severity="success"
          open={openSuccessMessage}
          handleClose={handleClose}
        />
      )}

      <BgBox>
        <CardUI
          padding="40px"
          paddingTop="40px"
          overflow="hidden"
          maxHeight="calc(100vh - 32px)"
        >
          <Box
            component="form"
            display="flex"
            gap="24px"
            flexDirection="column"
            width="100%"
            minHeight={0}
            flex={1}
            overflow="hidden"
          >
            <Stack flexShrink={0} gap="16px">
              <HeaderText
                variant="h3"
                fontSize={48}
                textContent={
                  showPractiseBox ? "Add Practice" : "Your Practices"
                }
              />
              <HeaderText
                variant="body1"
                fontSize={16}
                fontWeight={400}
                color="#566875"
                textContent="As a care management group you can setup & manage multiple practices"
              />
            </Stack>

            <Box
              sx={{
                flex: "1 1 auto",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                overflow: "hidden",
              }}
            >
              {!showPractiseBox &&
                ((existingAgencies?.length || agencies?.length) &&
                  !emailErrorMsg) && (
                  <HeaderText
                    variant="subtitle2"
                    fontSize="1.4rem"
                    textContent="Existing practices associated to your email"
                    lineHeight="24px"
                    sx={{ flexShrink: 0 }}
                  />
                )}

              <Box
                sx={{
                  flex: "1 1 auto",
                  minHeight: 0,
                  overflowY: "auto",
                }}
              >
                {!showPractiseBox && (
                  <ExistingPractices
                    existingAgencies={existingAgencies}
                    agencies={agencies}
                    emailErrorMsg={emailErrorMsg}
                    showHeading={false}
                  />
                )}

              {showPractiseBox && (
                <Stack gap="16px">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="body2" fontWeight={500}>
                      Add Practice
                    </Typography>
                    {addingMorePractice && (
                      <Button
                        variant="text"
                        onClick={closePractiseBoxHandler}
                      >
                        Cancel
                      </Button>
                    )}
                  </Box>
                  <AddPractiseContent
                    email={email}
                    emailChangeHandler={emailChangeHandler}
                    emailError={emailError}
                    practiseName={practiceName}
                    setPractiseName={setPracticeName}
                    ownerName={ownerName}
                    setOwnerName={setOwnerName}
                    specialtyId={specialtyId}
                    setSpecialtyId={setSpecialtyId}
                    specialtyError={specialtyError}
                    setSpecialtyError={setSpecialtyError}
                  />
                </Stack>
              )}

              {addingMorePractice && showPractiseBox && (
                <Box mt="16px">
                  <ExistingPractices
                    existingAgencies={existingAgencies}
                    agencies={agencies}
                    emailErrorMsg={emailErrorMsg}
                  />
                </Box>
              )}
            </Box>

            <Box flexShrink={0} display="flex" flexDirection="column" gap="16px">
              {!showPractiseBox && (
                <Button
                  size="large"
                  onClick={showMorePractiseHandler}
                  color="secondary"
                  sx={{
                    bgcolor: "#F4F6F8",
                    textTransform: "capitalize",
                    fontSize: "16px",
                  }}
                  startIcon={<AddPractiseIcon />}
                >
                  Add
                </Button>
              )}
              <LoadingButton
                fullWidth
                loading={
                  showPractiseBox ? loadingAgency || loadingAgent : false
                }
                variant="contained"
                sx={{ padding: "8px 22px", fontSize: 15 }}
                onClick={
                  showPractiseBox ? addPracticeHandler : joinWorkspaceHandler
                }
              >
                {showPractiseBox ? "Add Practice" : "Continue"}
              </LoadingButton>
            </Box>
          </Box>
          </Box>
        </CardUI>
      </BgBox>
    </>
  );
};

export default JoinWorkspace;
